// ---------------------------------------------------------------------------
// Sweep 3a. Where a getting-started step sends somebody.
//
// THE API NAMES A SCREEN, NEVER AN ADDRESS, and this turns the name into a path
// through the route table — so a screen that moves takes its links with it. Pure
// and outside the component, so "an id the console does not have draws no link"
// is asserted rather than hoped.
// ---------------------------------------------------------------------------

import { SURFACE_PREFIX } from "./navigation";
import { SCREENS, demoUrlFor, parametersIn } from "./screens";

/**
 * The path for one step, or null when there is nothing safe to link to: an id the
 * route table does not hold, a public screen, or a `:param` the step did not fill.
 *
 * `demoUrlFor` is the route table's own substitution, reused rather than copied —
 * it is named for the gallery, but what it does is turn a screen and its params
 * into the address the router matches, which is this question exactly.
 */
export function stepHref(step: { screen: string; params: Record<string, string> | null }): string | null {
  const screen = SCREENS.find((s) => s.id === step.screen);
  if (!screen || screen.home === "public") return null;
  const params = step.params ?? {};
  if (parametersIn(screen.path).some((name) => !params[name])) return null;
  return demoUrlFor({ ...screen, params }, SURFACE_PREFIX);
}
